import { UnitActivationStatus } from '@apps-common/config/unit-activation'

export const useUnitActivationStatusOptions = (status: string, isArchived: boolean) => {
  const showRetry = (): boolean => {
    if (!isArchived && status === UnitActivationStatus.failed) {
      return true
    }

    return false
  }

  const showActivate = (): boolean => {
    if (!isArchived && status === UnitActivationStatus.awaitingstart) {
      return true
    }

    return false
  }

  const showDelete = (): boolean => {
    if (!isArchived && status === UnitActivationStatus.cancelled) {
      return true
    }

    return false
  }

  const showArchive = (): boolean => {
    if (!isArchived && status === UnitActivationStatus.success) {
      return true
    }

    return false
  }

  const showEdit = (): boolean => {
    if (!isArchived && status === UnitActivationStatus.cancelled) {
      return true
    }

    return false
  }

  const canCancel = (): boolean => {
    if (
      !isArchived &&
      (status === UnitActivationStatus.awaitingstart ||
        status === UnitActivationStatus.failed ||
        status === UnitActivationStatus.awaitingpowerup)
    ) {
      return true
    }

    return false
  }

  return {
    isProcessing: status === UnitActivationStatus.pending,
    showRetry: showRetry(),
    showActivate: showActivate(),
    showDelete: showDelete(),
    showArchive: showArchive(),
    showEdit: showEdit(),
    canCancel: canCancel()
  }

  // return {
  //   isProcessing: true,
  //   showRetry: true,
  //   showActivate: true,
  //   showDelete: true,
  //   showArchive: true,
  //   showEdit: true,
  //   canCancel: true
  // }
}
